export var UserType;
(function (UserType) {
    UserType["USER_TYPE_LOCAL"] = "LOCAL";
})(UserType || (UserType = {}));
